import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import { images } from "../../../constants/images";
import {
  StyledBtnClose,
  StyledModalContent,
  StyledModalSuccess,
} from './styled';

//Service
import { getPin } from '../../../services/user';
import { Spin } from 'antd';

function ModalPin(props) {
  const { userId, visible, onCancel } = props;

  const [isCopied, setIsCopied] = useState(false);
  const [pin, setPin] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  // const [page, setPage] = useState(1);

  useEffect(() => {
    if (userId && visible) {
      getPinData(userId);
    }
  }, [visible]);

  async function getPinData(userId) {
    setIsLoading(true);
    setIsCopied(false);

    const res = await getPin({ userId });
    setPin(res.code);

    setIsLoading(false);
  }

  function onClearData() {
    onCancel();
  }

  function handleCopy() {
    navigator.clipboard.writeText(pin);
    setIsCopied(true);
  }

  function renderPin() {
    return (
      <>
        <h1>Pin Generator</h1>
        <div className="result">
          {isLoading ? (
            <Spin />
          ) : (
            <>
              <div className="label-pin">{pin}</div>
              {!isCopied ? (
                <div className="label-copy-pin" onClick={handleCopy}>
                  Click to copy
                </div>
              ) : (
                <div className="label-copy-success">
                  Code copied to clipboard
                </div>
              )}
            </>
          )}
        </div>
      </>
    );
  }

  return (
    <StyledModalSuccess
      title={false}
      visible={visible}
      footer={false}
      closable={false}
      centered={true}
      onCancel={onClearData}
    >
      <StyledModalContent>
        {renderPin()}
        <StyledBtnClose onClick={onClearData}>Close</StyledBtnClose>
      </StyledModalContent>
    </StyledModalSuccess>
  );
}

ModalPin.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  result: PropTypes.string,
  dataRecords: PropTypes.array,
  eventName: PropTypes.string,
  keyReponse: PropTypes.string,
  messenger: PropTypes.string,
  userId: PropTypes.string,
};

export default ModalPin;
